import axios from 'axios'

export default axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT_V2,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
})
